import { RequestCheckoutState } from '@shared/types';
import { FunctionComponent, useMemo } from 'react';
import { useRequestCheckoutContext } from '../../CheckoutContext/RequestContext';
import { DeliveryStep } from './DeliveryStep';
import { MessageStep } from './MessageStep';
import { ContactDetailsStep } from '../../ContactDetailsStep';
import { ConfirmationStep } from './ConfirmationStep';
import { CheckoutFlowWrapper } from '../../CheckoutFlowWrapper';
import { DatesStep } from './DatesStep';
import { PaymentStep } from './PaymentStep';

export type RequestFlowProps = {};

const RequestStep: FunctionComponent<RequestFlowProps> = () => {
    const { checkoutState } = useRequestCheckoutContext();
    switch (checkoutState.currentStep) {
        case 'delivery':
            return <DeliveryStep />;
        case 'message':
            return <MessageStep />;
        case 'dates':
            return <DatesStep />;
        case 'contactDetails':
            return <ContactDetailsStep />;
        case 'payment':
            return <PaymentStep />;
        case 'confirmation':
            return <ConfirmationStep />;
        default:
            return <p>Unknown step</p>;
    }
};

const unauthenticatedSteps: Array<{ key: RequestCheckoutState['currentStep']; label: string }> = [
    {
        key: 'delivery',
        label: 'Delivery options',
    },
    {
        key: 'dates',
        label: 'Dates',
    },
    {
        key: 'message',
        label: 'Message',
    },
];

const allAuthenticatedSteps: Array<{ key: RequestCheckoutState['currentStep']; label: string }> = [
    {
        key: 'contactDetails',
        label: 'Contact Info',
    },
    {
        key: 'payment',
        label: 'Payment',
    },
    {
        key: 'confirmation',
        label: 'Confirmation',
    },
];

export const RequestFlow: FunctionComponent<RequestFlowProps> = () => {
    const { requiresPayment } = useRequestCheckoutContext();

    const authenticatedSteps = useMemo(() => {
        if (requiresPayment) {
            return allAuthenticatedSteps;
        }
        return allAuthenticatedSteps.filter((step) => step.key !== 'payment');
    }, [requiresPayment]);

    return (
        <CheckoutFlowWrapper
            authenticatedSteps={authenticatedSteps}
            unauthenticatedSteps={unauthenticatedSteps}
        >
            <RequestStep />
        </CheckoutFlowWrapper>
    );
};
